import { size } from "lodash";

export default {
  auth: {
    login: 'Inloggen',
    logout: 'Uitloggen',
    no_match: 'De wachtwoorden komen niet overeen',
    forgot: {
      title: 'Wachtwoord vergeten',
      instruction: 'Voer je e-mailadres in en ontvang een mail om een nieuw wachtwoord aan te maken.',
      confirmation: 'We hebben je een nieuw wachtwoord gemaild.',
      submit: 'Opvragen',
    },
    reset: {
      title: 'Wachtwoord resetten',
      instruction: 'Maak een nieuw wachtwoord aan',
      submit: 'reset',
      submitted: 'Uw wachtwoord is gewijzigd.'
    },
    submitted: {
      success: 'Gelukt!',
      sent: 'We hebben een mail gestuurd aan {email}.',
      again: 'Log opnieuw in',
    },
    required: {
      email: 'Ongeldige email',
      password: 'Wachtwoord is verplicht',
      default: 'Verplicht',
      name: 'Ongeldige naam',
      url: 'Ongeldige url',
      number: 'Alleen cijfers toegestaan',
      passwordRules: {
        lowercase: 'Eén kleine letter vereist',
        uppercase: 'Eén hoofdletter vereist',
        length: 'Minimaal 8 karakters',
        number: 'Eén nummer vereist',
        special: 'Eén speciale character vereist',
        match: 'Wachtwoorden moeten overeen komen',
      },
    },
  },
  actions: {
    back: 'Terug',
    next: 'Volgende',
    add: 'Toevoegen',
    edit: 'Aanpassen',
    save: 'Opslaan',
    create: 'Aanmaken',
    close: 'Sluiten',
    esc: 'esc',
    upload: 'Upload',
  },
  labels: {
    description: 'Toelichting',
  },
  event: {
    title: 'Uren registratie',
    dialog: {
      create: 'Schrijf uren',
      edit: 'Pas aan',
      remove: 'Verwijder',
    },
  },
  mfa: {
    title: 'mfa token',
  },
  roles: {
    user: 'Gebruiker | Gebruikers',
  },
  user: {
    add: '{item} toevoegen',
    title: 'Gebruiker',
    statuses: {
      active: 'Actief',
      blacklist: 'Blacklist',
      discontinued: 'Uit de handel',
      openInvoice: 'Open factuur',
    },
  },
  category: {
    title: 'Categorie',
  },
  tag: {
    title: 'Label',
  },
  material: {
    title: 'Materiaal',
  },
  image: {
    title: 'Foto',
  },
  attribute: {
    title: 'Attribuut',
  },
  supplier: {
    title: 'Leverancier',
  },
  size: {
    title: 'Maat',
  },
  brand: {
    title: 'Merk',
  },
  request:
  {
    request: 'Aanvraag',
    boxRequestNotFound: 'Box Aanvraag niet gevonden of kan niet worden geladen.',
    assignedAt: 'Toegewezen op',
    noLogsAvailable: 'Geen logs beschikbaar',
    statusChangedTo: 'status gewijzigd naar',
    by: 'door',

  },
  table: {
    found: '{total} {name} gevonden',
    perPage: '{name} per pagina:',
    noData: 'Geen gegevens beschikbaar',
    filter: 'Filter op {name}:',
    listView: 'Lijstweergave',
    kanBanView: 'KanBan-weergave',
    toggleFilters: 'Filters tonen/verbergen',
  },
  tableHeaders: {
    name: {
      title: 'Naam',
      first: 'Voornaam',
      middle: 'Tussenvoegsel',
      last: 'Achternaam',
    },
    age: {
      title: 'Leeftijd',
    },
    email: {
      title: 'Email'
    },
    phone: {
      title: 'Telefoonnummer'
    },
    created_at: {
      title: 'Aangemaakt op',
    },
    price: {
      title: 'Prijs',
    },
    code: {
      title: 'Code',
    },
    percentage: {
      title: 'Percentage',
    },
    status: {
      title: 'Status'
    },
    adressChecked: {
      title: 'Adres Gecheckt'
    },
    city: {
      title: 'Woonplaats'
    },
    number: {
      title: 'Nummer',
    },
    userID: {
      title: 'User ID'
    },
    createdAt: {
      title: 'Aangemaakt op'
    },
    client: {
      title: 'Klant',
    },
    type: {
      title: 'Type',
    },
    stylist: {
      title: 'Stylist',
    },
    note: {
      title: 'Notitie',
    },
    boxNumber: {
      title: 'Box #',
    },
    channel: {
      title: 'Kanaal',
    },
    assignedAt: {
      title: 'Toegewezen op',
    },
    lastStatusUpdate: {
      title: 'Laatste Statusupdate',
    },
    lastUpdate: {
      title: 'Laatste update',
    },
    orderNumber: {
      title: 'Order #',
    },
    quantity: {
      title: 'Hoev.',
    },
    quantitySold: {
      title: 'Verkochte Hoev.',
    },
    netSales: {
      title: 'Netto Verkoop',
    },
    finalized: {
      title: 'Afgerond',
    },
    dispatched: {
      title: 'Verzonden',
    },
    finalReturn: {
      title: 'Definitieve Retour',
    },
    returned: {
      title: 'Geretourneerd',
    },
    picked: {
      title: 'Gepickt'
    },
    barcode: { title: 'Barcode' },
    offeredOn: { title: 'Aangeboden op' },
    deliveryDate: { title: 'Afleverdatum' },
    labels: { title: 'Labels' },
    understanding: { title: 'Begrip' },
  },
  navigation: {
    users: 'Users',
  },
  profile: {
    title: 'Profiel | Profielen',
    setting: 'Instelling | Instellingen',
    mine: 'Mijn profiel',
    standard: 'Standard Informatie',
    referral_code: 'Kortingscode',
    contact: {
      information: 'Contact Informatie',
      person: 'Contactpersoon',
      number: 'Contact nummer',
    },
    dob: 'Geboortedatum',
    name: 'Naam',
    firstName: 'Voornaam',
    middleName: 'Middelnaam',
    lastName: 'Achternaam',
    email: 'Email',
    phone: 'Telefoonnummer',
    website: 'Website',
    country: 'Land',
    company: 'Bedrijfsnaam',
    password: {
      title: 'Nieuw wacthwoord',
      forgot: 'Wachtwoord vergeten?',
      current: 'Huidig wachtwoord',
      confirm: 'Wacthwoord bevestigen',
      change: 'Wachtwoord wijzigen',
      save: 'Wachtwoord opslaan',
      saved: 'Wachtwoord opgeslagen',
    },
    group: 'Groep',
    login: 'Inloggen als',
    address: 'Adres',
    street: 'Straatnaam',
    housenumber: 'Huisnummer',
    addition: 'Toevoeging',
    postcode: 'Postcode',
    city: 'Woonplaats',
    budgetHours: 'Budget uren',
    budgetMoney: 'Budget geld',
    code: 'Code',
    color: 'Kleur',
    invoiceName: 'Factuur naam',
    calculationModel: 'Calculatie model',
    responsibleEmployee: 'Medewerker',
  },
  avatar: {
    title: 'Profiel foto',
    change: 'Wijzig foto',
  },
  general: {
    back: 'Terug',
    search: 'Zoek | Zoeken',
    cancel: 'annuleren',
    yes: 'Ja',
    no: 'Nee',
    active: 'Actief',
    inactive: 'Niet actief',
    startsAt: 'Begint op',
    endsAt: 'Eindigt op',
  },
  time: {
    year: 'jaar | jaren',
    month: 'maand | maanden',
    week: 'week | weken',
    day: 'dag | dagen',
    hour: 'uur | uren',
    minute: 'minuut | minuten',
  },
  inbox: {
    title: '',
    menu: {
      inbox: 'Inbox',
      starred: 'Uitgelicht',
      sent: 'Verzonden',
      draft: 'Concept',
      create: 'Nieuwe e-mail',
      folders: 'Mappen',
    },
    actions: {
      delete: 'Verwijderen',
      reply: 'Beantwoorden',
      archive: 'Archiveren',
      sent: 'Versturen',
      confirm: 'Ok',
    },
    contact: 'Contact | Contacten'
  },
  form: {
    formFields: {
      avatar: 'Avatar',
      supplierName: 'Naam leverancier',
      firstName: 'Voornaam',
      lastName: 'Achternaam',
      middleName: 'Tussenvoegsel',
      name: 'Naam',
      invoiceName: 'Factuur naam',
      website: 'Website',
      phone: 'Telefoon',
      username: 'Gebruikersnaam',
      email: 'Email',
      password: 'Wachtwoord',
      category: 'Categorie',
      confirmPassword: 'Bevestig wachtwoord',
      code: 'Code',
      percentage: 'Percentage',
      color: 'Project kleur',
      token: 'MFA Token',
      value: 'Waarde',
      crediteur: 'Crediteur',
      country: {
        title: 'Land',
        nl: 'Nederland',
        en: 'Engeland',
        de: 'Duitsland',
      },
    },
    optional: 'Optioneel',
    fieldsRequiredText: 'Alle velden zijn verplicht',
  },
  languages: {
    title: 'Taal',
    nl: 'Nederlands',
    en: 'Engels',
    de: 'Duits'
  },
  createDialog: {
    header: {
      create: 'Aanmaken',
      overview: 'Overzicht',
      finished: 'Voltooid',
    },
    body: {
      title: {
        activate: 'Activeer de {role}',
        create: 'Maak een {role} aan',
        finished: '{role} is aangemaakt',
        information: '{role} informatie',
        billingAddress: 'Factuuradres',
        postAddress: 'Postadres',
        officeAddress: 'Bezoekadres',
        address: 'Adres',
      },
      description: {
        confirm: 'Bevestig of alle informatie juist is voor de nieuwe {role}',
        finished: 'Bekijk hieronder de aangemaakte {role}',
      },
      upload: 'Uploaden',
    },
    actions: {
      reset: 'Maak nog een {role} aan',
    },
  },
  dialogOptions: {
    item: {
      client: 'Cliënt',
      subscriptionType: 'Abonnementsoort',
      user: 'gebruiker',
    },
    confirmation: 'Bevestiging',
    delete: 'Weet je zeker dat je dit {item} wilt verwijderen? | Weet je zeker dat je deze {item} wilt verwijderen?',
    deleteMany: 'Weet je zeker dat je deze {item} wilt verwijderen?',
    lesson: 'Weet je zeker dat je deze {item} wilt kiezen?',
    save: '{item} is opgeslagen',
    update: 'Weet je zeker dat je dit {item} wilt update? | Weet je zeker dat je deze {item} wilt updaten?',
    existingOrderFound: 'Bestaande order gevonden',
    existingOrderFoundForClient: 'Er is al een order voor deze klant',
    showOrder: 'Toon order',
    button: {
      delete: 'Verwijder',
      cancel: 'Nee dat wil ik niet',
      ok: 'Oke',
      close: 'Sluit',
    },
  },
  bugReport: {
    title: 'Bug',
    header: 'Meld een bug',
    field: {
      title: 'Titel',
      description: 'Omschrijving',
      screenshot: 'Afbeelding',
    },
    create: {
      title: 'Voeg een titel toe',
      description: 'Voeg een omschrijving toe',
      descriptionExplanation: 'Hoe is deze bug onstaan? Welke stappen heb je doorlopen? Welke knoppen heb je geklikt?',
      screenshot: 'Schermafbeelding',
      submitBug: 'Bug melden',
      created: 'Bug melding is aangemaakt.',
      downloadScreenshot: 'Download de afbeelding',
      uploadScreenshot: 'Upload de gedownloade afbeelding in de link',
    },
    alert: {
      noIdSet: 'Monday Board Id of Group Id is niet ingesteld, kan geen puls genereren',
      warning: 'Waarschuwing',
    },
    reportContent: {
      description: 'Omschrijving',
      localStorage: 'Lokale opslag',
      stacktrace: 'Stacktrace',
      message: 'Bericht',
      file: 'Bestand',
      line: 'Regel',
      column: 'Kolom',
      error: 'Error',
    },
  },
  errors: {
    loading: {
      description: 'Er is een probleem opgetreden bij het laden van de vereiste informatie.',
      suggestion: 'Probeer het later opnieuw.',
    },
    notFound: {
      description: 'De door jouw opgevraagde pagina is niet gevonden.',
      suggestion: '404',
      url: 'Controleer de URL voor eventuele typefouten',
      error: '404 ERROR.',
      back: 'ga naar home',
      oops: 'Oeps :(',
      or: 'of',
      contact: 'Neem contact met ons op via',
    },
  },
  hours: {
    hour: 'Uurregel | Uurregels',
  },
  contact: 'Contact',
  contacts: 'Contacten',
  menu: {
    requests: 'Aanvragen',
    orders: 'Orders',
  },
  hamburgerMenu: {
    account: 'Mijn account',
    settings: 'Instellingen',
  },
  filters: {
    filters: 'Filters',
    statusFilter: {
      toBeContacted: 'Te contacteren',
      waitingForReply: 'Wachten op antwoord',
      noReply: 'Geen antwoord',
      orderInProgress: 'Te stylen',
      completed: 'Voltooid',
    },
    typeFilter: {
      swapBox: 'Ruilbox',
      styledBox: 'Gestylede Box',
      studio: 'Studio',
      afterSales: 'After Sales',
      promotion: 'Promotie',
      supplierReturn: 'Leveranciersretour',
      swipeToShop: 'Swipe-om-te-kopen',
      shopify: 'Shopify',
      stylingFee: 'Stylingkosten',
      other: 'Anders',
    },
    orderStatusFilter: {
      active: 'Actief',
      inactive: 'Inactief',
      preview: 'Voorbeeld',
      finalized: 'Geëindigd',
      checkout: 'Afrekenen',
      invoiced: 'Gefactureerd',
      completed: 'Voltooid',
      lost: 'Verloren',
      cancelled: 'Geannuleerd',
      allocated: 'Toegewezen',
      partiallyAllocated: 'Gedeeltelijk toegewezen',
      picked: 'Gepickt',
      partiallyPicked: 'Gedeeltelijk gepickt',
      shipped: 'Verzonden',
      partiallyShipped: 'Gedeeltelijk verzonden',
      dispatched: 'Verstuurd',
      partiallyDispatched: 'Gedeeltelijk verstuurd',
    },
    finalReturnDate: 'Laatste retourdatum',
  },
  contactsPage: {
    cardview: {
      newOrder: 'Nieuwe order aanmaken',
      editStatus: 'Wijzig door op een status te klikken',
      createNewOrder: 'Nieuwe order aanmaken',
      finishOrder: 'Bestelling afronden',
      fillAdress: 'Vul de adresgegevens in en ga verder met de order',
    },
    quizView: {
      styleQuiz: 'Stijlquiz',
      quizCreatedAt: 'Stijlquiz ingevuld op:',
      style: 'Stijl',
      bodyType: 'Figuur',
      preferences: 'Voorkeur',
      myFotos: 'Mijn foto\'s',
      box: 'Box',
      notes: 'Stylist Notes',
    },
    attachments: 'Bijlagen',
    listView: {
      search: 'Zoeken',
      signUpDate: 'Aangemeld op',
    },
  },
  orders: {
    checkOrder: 'Bekiijk order',
    orderDetail: {
      orderItems: 'Bestelitems',
      relatedSets: 'Gerelateerde sets',
      evaluation: 'Evaluatie',
      attachments: 'Bijlagen',
      labels: 'Labels',
      updateOrder: 'Update order',
      orderItemsBlock: {
        notAllocatedItems: 'Niet toegewezen items',
        itemName: 'Artikelnaam',
        quantity: 'Aantal',
        price: 'Prijs',
        tax: 'Belasting',
        total: 'Totaal',
        allocatedItems: 'Toegewezen items',
        noItemsAreAllocated: 'Geen items toegewezen',
        pickedItems: 'Gekozen items',
        noItemsArePicked: 'Geen items gekozen',
        dispatchedItems: 'Verzonden items',
        noItemsAreDispatched: 'Geen items verzonden',
        returnedItems: 'Geretourneerde items',
        noItemsAreReturned: 'Geen items geretourneerd',
        returnBatch: 'Retourbatch',
        keptItems: 'Behouden items',
        discount: 'Korting',
        noItemsAreKept: 'Geen items behouden',
        totalUnits: 'Totale eenheden',
        subTotal: 'Subtotaal',
        referralDiscount: 'Korting via doorverwijzing',
        includingVat: 'Inclusief BTW (21%)',
        returnDate: 'Retourdatum',
        orderDiscount: 'Orderkorting',
      },
      relatedSetsBlock: {
        newSet: 'Nieuwe sets',
        size: 'Maat:',
        brand: 'Merk:',
        editPersonalNote: 'Personal Note aanpassen:',
        createdAt: 'Aangemaakt',
        cancel: 'Annuleer',
      },
      evaluationBlock: {
        orderEvaluation: 'Order evaluatie',
        stylistUnderstanding: 'In hoeverre heb je het gevoel dat jouw styliste jouw stijl goed heeft begrepen?',
        anotherBox: 'Denk je dat je het leuk zou vinden om een volgende box te ontvangen?',
        satisfiedWithBox: 'In hoeverre ben jij tevreden met de box?',
        willYouAdvise: 'In hoeverre is het waarschijnlijk dat jij Maison365 zou aanbevelen bij anderen?',
        isTheChoiceGood: 'In hoeverre ben je het eens met de stelling dat je met Maison365 op een makkelijke manier aan leuke kleding kankomen?',
      },
      orderedItemsEvaluation: {
        orderItemsEvaluation: 'Order Items Evaluatie',
        product: 'Product',
        overall: 'Overall',
        fit: 'Pasvorm',
        style: 'Stijl',
        other: 'Overig',
        good: 'Goed',
        size: 'Maat',
        tooLarge: 'Te groot',
        tooSmall: 'Te klein',
        keep: 'Houden',
        return: 'Retour',
        exchange: 'Ruilen',
        tooWide: 'Te wijd',
        tooTight: 'Te strak',
        tooLong: 'Te lang',
        tooShort: 'Te kort',
        tooSimple: 'Te simpel',
        tooBusy: 'Te druk',
        tooSolid: 'Te degelijk',
        tooYoung: 'Te jong',
        colorNotNice: 'Kleur niet mooi',
        printNotNice: 'Print niet mooi',
        materialFinishingNotNice: 'Stof/Afwerking niet mooi',
        tooExpensive: 'Te duur',
        alreadyHaveSomethingSimilar: 'Ik heb al zoiets',
        generalEvaluation: "Overall beoordeling",
        sizeEvaluation: "Maat beoordeling",
        fitEvaluation: "Pasvorm beoordeling",
        styleEvaluation: "Stijl beoordeling",
        otherEvaluation: "Overige beoordeling",
      },
      attachmentsBlock: {
        orderAttachments: 'Order attachments',
        noOrderAttachments: 'Op dit moment zijn er geen order attachments.',
        seeOrderAttachments: 'Bekijk order attachments',
      },
      listView: {
        nanOrdersFound: 'NaN Orders gevonden',
        search: 'Zoeken',
        ordersPerPage: 'Orders per pagina',
      },
      webshop: {
        filters: {
          search: 'Zoek naar product',
          colors: 'Kleuren',
          brands: 'Brands',
          suppliers: 'Suppliers',
          categories: 'Categories',
          tags: 'Tags',
          materials: 'Materialen',
          price: 'Prijs',
          sizes: 'Maten',
          season: 'Season',
          pantsLength: 'Broeklengte',
          details: 'Details',
          sustainable: 'Duurzaam',
          pantsFit: 'Fit broeken',
          jacketsFit: 'Fit Jasjes',
          dressesFit: 'Fit jurkjes',
          topsFit: 'Fit tops',
          collar: 'Halslijn',
          jacketsLength: 'Lengte jasjes',
          dressesLength: 'Lengte jurkjes',
          topsLength: 'Lengte tops',
          sizeGuide: 'Maatrichtlijn',
          material: 'Materiaal',
          sleeveSize: 'Mouwlengte',
          pattern: 'Patroon',
          closure: 'Sluiting',
          style: 'Stijl',
          pantsType: 'Type Broek',
          jacketsType: 'Type Jasjes',
          skirtType: 'Type Rok',
          rerun: 'Rerun',
          dummyUPC: 'Dummy UPC',
          removeAllFilters: 'Alle filters wissen',
        },
        styleView: {
          availableSizes: 'Beschikbare maten',
        },
        sideBar: {
          height: 'Lengte',
          cup: 'Cup',
          jeans: 'Jeans',
          tops: 'Tops',
          topSize: 'Boven',
          bottomSize: 'Onder',
          customer: 'Klant',
          style: 'Stijl',
          brands: 'Merken',
          keywords: 'Keywords',
          dresscodeAtWork: 'Dresscode Werk',
          monthlyBudget: 'Maand budget',
          colors: 'Kleuren',
          shoppingCart: 'Winkelmandje',
          size: 'Maat',
          total: 'Totaal:',
          createSets: 'Set Aanmaken',
          client: 'Klant',
          items: 'Artikelen',
          colorDontUse: 'Welke kleuren draag je niet',
          fabricDontUse: 'Welke stoffen draag je niet',
          patternDontUse: 'Welke prints draag je niet',
          camouflage: 'Camoufleren',
          motivation: 'Motiviatie',
          thisBox: 'Deze box',
          lookingFor: 'Vooral op zoek naar',
          specificItems: 'Specifieke items die de klant wilt ontvangen',
          other: 'Overig',
          shapePreferenceTops: 'Pasvorm voorkeur tops',
          budget: 'Budget',
          trousers: 'Broeken',
          fittingTrousers: 'Hoe passen broeken jou meestal in de taille?',
          skirts: 'Rokken',
          dresses: 'Jurken',
          lengthSkirt: 'Welke lengte rok past bij jou?',
          accessories: 'Accessoires',
          describeAccessories: 'Hoe omschrijf je jouw stijl voor accessoires en sieraden?',
          preferenceColor: 'Voorkeur sieraden kleur',
          earsPierced: 'Heb je gaatjes in je oren?',
          noProductsCart: 'Er zijn geen producten in het winkelmandje',
        },
        productView: {
          backToTheShop: 'Terug naar de shop',
          inStock: 'Op Voorraad',
          productDetailsPhotosOkNotOk: 'Productdetails & foto\'s OK/NIET OK voor kleur Dark blue, maat 36?',
          addToCart: 'Toevoegen',
          color: 'Kleur',
          productAttributes: 'Product Attributen',
          supplierCode: 'Leverancierscode',
          location: 'Locatie',
          selectOtherSize: 'Selecteer andere maat',
          outOfStock: 'Niet op voorraad',
          productAlreadyInCart: 'Dit product staat al in uw winkelwagentje',
          availableInShopify: 'Beschikbaar in Shopify',
          reserved: 'Gereserveerd',
          noMaterials: 'Geen materialen voor dit product',
          noTags: 'Geen tags voor dit product'
        },
        sets: {
          addAllToOtherItems: "Voeg alles toe aan overige artikelen",
          otherItems: 'Overige artikelen',
          totalPrice: 'Totaal prijs:',
          totalProducts: 'Totaal producten:',
          createPersonalNote: 'Personal Note maken',
          newSet: 'Nieuwe set',
          back: 'Terug',
          tip: "TIP:",
          packInThisSet: 'In deze set inpakken',
          setExplanation: 'Set uitleg',
        },
        personalNote: {
          personalNote: 'Personal Note',
          updatePersonalNote: 'Personal Note aanpassen',
          totalPrice: 'Totaal prijs: ',
          totalProducts: 'Totaal producten:',
          finalizeThisOrder: 'Bestelling definitief maken',
          introText: 'Introductie Tekst',
          noExplanationForSet: 'Er is geen uitleg gegeven bij deze set',
          outroText: 'Outro Tekst',
          back: 'Terug',
          originalText: 'Oorspronkelijke Tekst',
          selectLanguageNote: 'Selecteer de Personal Note taal voor jouw klant',
          inOriginalLanguage: 'In originele taal weergeven',
          translateToOtherLanguage: 'Vertalen naar een andere taal',
          selectLanguage: 'Selecteer taal',
          translate: 'Vertalen',
          translatedText: 'Vertaald tekst',
          orderSucceded: 'Bestelling gelukt',
          orderDefinitive: 'De bestelling is definitief gemaakt.',
          orderOverview: 'Naar het order overzicht',
          editPersonalNotes: 'Personal Notes aanpassen',
          update: 'Bijwerken',
          cancel: 'Annuleren',
          sureYouWantToUpdate: 'Weet je zeker dat je deze personal note wilt updaten?',
        },
        maia: {
          name: 'Maia',
          subtitle: 'Styling Support',
          openChat: 'Vraag het Maia',
          you: 'Jij',
          placeholder: 'Typ een bericht..',
          viewProduct: 'Product bekijken',
          greeting: 'Hoi! Ik help je graag met het samenstellen van deze box. Waar wil je mee beginnen?',
          greetingNamed: 'Hoi! Ik help je graag met de box voor {customer}. Waar wil je mee beginnen?',
          error: 'Sorry, ik kon even geen antwoord ophalen. Probeer het nog eens.',
          suggestions: {
            jeans: 'Welke jeans passen bij deze klant?',
            eyeCatcher: 'Stel een eye-catcher voor onder €150',
            missing: 'Wat mist er nog in deze box?',
          },
          // De crosscheck met het klantprofiel, per aanbeveling. De sleutels
          // komen van de backend (MaiaRecommendationCheck) zodat de tekst hier
          // in de taal van de stylist staat en niet in die van het model.
          checks: {
            notChecked: 'Niet te controleren',
            over: '{amount} boven budget',
            breaks: '{rule} klopt niet',
            rules: {
              size: 'maat',
              colour: 'kleur',
              dress: 'geen jurk',
              budget: 'budget',
              wishlist: 'op haar wensenlijst',
              fabric: 'stof',
              print: 'print',
              camouflage: 'camoufleren',
              profile: 'geen profiel',
            },
          },
        }
      }
    }
  },
  mfaSetup: {
    mfaNotYetSetup: 'MFA nog niet ingesteld',
    mfa: "MFA instellen",
    mfaSetup: "MFA-token instellen",
    step1: "Pak je telefoon erbij.",
    step1_ios: 'Als je een <b>iPhone</b> hebt, open dan de App Store en zoek op <b>"Step Two"</b>.',
    step1_android: 'Als je een <b>Android-telefoon</b> hebt, open dan de Play Store en zoek op <b>"Google Authenticator"</b>.',
    step1_download: "Download deze app vervolgens op je telefoon.",
    step2: "Open de zojuist gedownloade app en voeg de token toe.",
    step2_steptwo: '<b>Step Two</b>: Druk op het + icoon en scan de onderstaande QR-code:',
    step2_google: '<b>Google Authenticator</b>: Start de configuratie en druk op “Streepjescode scannen”.',
    step2_scan: "Scan nu de onderstaande QR-code",
    step3: "Na het scannen van de QR-code zie je een 6-cijferige code met een tijdklokje erbij. Deze verloopt elke 30 seconden.",
    step4: 'Voer de code uit je app in bij <b>"Token 1"</b>.',
    step5: "Wacht nu totdat de code verloopt, en voer dan de nieuwe code in bij <b>'Token 2'</b>.",
    step6: 'Rond het instellen af met de knop <b>"Token opslaan"</b>.',
    token1_label: "Token 1",
    token2_label: "Token 2",
    save_token: "Token opslaan",
    cancel: "Annuleren"
  },
};

